<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="60%"
        :destroy-on-close="true"
        :before-close="handleClose">
<div style="width:40%;margin-left:10%;" v-if="this.title == '添加'">
<el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign" >
  <el-form-item label="键值">
    <el-input v-model="formLabelAlign.value" size="small"></el-input> 
    <el-button type="primary" v-Jurisdiction="'sys:web:dict:manage:checkValue'"  style="float:right" size="small"  @click="DetectionVlaue()">检测</el-button>
  </el-form-item>
  <el-form-item label="标签">
    <el-input v-model="formLabelAlign.label" size="small"></el-input>
  </el-form-item>
  <el-form-item label="类型">
    <el-input v-model="formLabelAlign.type" size="small" ></el-input>
  </el-form-item>
    <el-form-item label="描述"  >
      <el-input v-model="formLabelAlign.description" size="small"></el-input>
    </el-form-item>
    <el-form-item label="排序" >
     <el-input v-model="formLabelAlign.sort" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
<div style="width:40%;margin-left:10%;" v-else>
<el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign" >
  <el-form-item label="键值">
    <el-input v-model="formLabelAlign.value" size="small" disabled></el-input> 
    <!-- <el-button type="primary" v-Jurisdiction="'sys:web:dict:manage:checkValue'"  style="float:right" size="small"  @click="DetectionVlaue()">检测</el-button> -->
  </el-form-item>
  <el-form-item label="标签">
    <el-input v-model="formLabelAlign.label" size="small"></el-input>
  </el-form-item>
  <el-form-item label="类型">
    <el-input v-model="formLabelAlign.type" size="small" disabled ></el-input>
  </el-form-item>
    <el-form-item label="描述"  >
      <el-input v-model="formLabelAlign.description" size="small"></el-input>
    </el-form-item>
    <el-form-item label="排序" >
     <el-input v-model="formLabelAlign.sort" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "PropertyDialog",
  data() {
    return {
     dialogVisible: false,
     title:"标题",
     labelPosition:'right',
     formLabelAlign:{},
     type:"",
     display:"",
     detection:"",
     UserDisplay:"",
    };
  },
  methods: {
    DetectionVlaue(){
      let  DetectionVlaue = this.formLabelAlign.value
      let obj = {
        value:DetectionVlaue,
        type:this.formLabelAlign.type,
      }
      if(obj.value == null || obj.value == undefined  || obj.value == ""){
          this.$message({
            type: 'warning',
            message: '请先填写键值'
          });  
      }else if(obj.type == null || obj.type == undefined  || obj.type == ""){
          this.$message({
            type: 'warning',
            message: '请先填写类型'
          });  
      }else{
          this.$http.post(this.$requestUrl.DETECTION_DICT,obj).then((res) => {
            if(res.data.msg == "键值可用！"){
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                });
            }
            }).catch(() => {
              this.$message.error(this.$errorMessage.SEVER_ERROR)
            })
      }
    },
    modification(){
      if(this.title == "修改"){
            let Dict = {
              "id":this.formLabelAlign.id,
              "label":this.formLabelAlign.label,
              "value":this.formLabelAlign.value,
              "type":this.formLabelAlign.type,
              "description":this.formLabelAlign.description,
              "sort":this.formLabelAlign.sort,
              "remarks":this.formLabelAlign.remarks,
            }
            this.$http.put(this.$requestUrl.PUT_DICT_AMEND,Dict).then((res) => {
            let result = res.data;
            if (200 === result.code) {
              this.dialogVisible = false
              this.$emit("Visible",false)
                      this.$message({
            type: 'success',
            message: '修改成功!'
          });
            } else {
              this.$message.error(result.msg)
            }
            }).catch(() => {
              this.$message.error(this.$errorMessage.SEVER_ERROR)
            })
      }else{
              let Dict = {
              "label":this.formLabelAlign.label,
              "value":this.formLabelAlign.value,
              "type":this.formLabelAlign.type,
              "description":this.formLabelAlign.description,
              "sort":this.formLabelAlign.sort*1,
              "remarks":this.formLabelAlign.remarks,
            }
              this.$http.post(this.$requestUrl.POST_DICT_ADD,Dict).then((res) => {
              let result = res.data;
              if (200 === result.code) {
                             this.dialogVisible = false
                   this.$emit("Visible",false)
                this.$message({
                              type: 'success',
                              message: '添加成功!'
                          });
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              }) 
      }

    },
    handleClose(done) {
     this.dialogVisible = false
    },
    amend(){
    }
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
  
  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>